// ============================================
// Số sao của một góp ý
// ============================================
// `rating` là `number | null`: `null` nghĩa là khách CHỈ viết chữ hoặc gửi ảnh,
// KHÔNG phải "0 sao". Vẽ 5 ngôi sao rỗng cho ca đó là bịa ra một đánh giá tệ mà
// khách chưa từng đưa — nên `null` trả về dấu gạch.

import { cn } from '../../../utils/cn';
import { EMPTY_VALUE } from '../feedbackText';

const MAX_STARS = 5;

interface RatingStarsProps {
  rating: number | null | undefined;
  size?: number;
  /** Hiện thêm con số bên cạnh (dùng ở modal chi tiết). */
  showValue?: boolean;
  className?: string;
}

function Star({ filled, size }: { filled: boolean; size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
      className={filled ? 'text-amber-400' : 'text-slate-300'}
      aria-hidden="true"
    >
      <path d="M10 2.5l2.35 4.76 5.25.76-3.8 3.7.9 5.23L10 14.48l-4.7 2.47.9-5.23-3.8-3.7 5.25-.76L10 2.5z" />
    </svg>
  );
}

export function RatingStars({ rating, size = 14, showValue = false, className }: RatingStarsProps) {
  if (rating == null) {
    return <span className={cn('text-sm text-slate-400', className)}>{EMPTY_VALUE}</span>;
  }

  const rounded = Math.max(0, Math.min(MAX_STARS, Math.round(rating)));

  return (
    <span
      className={cn('inline-flex items-center gap-0.5', className)}
      aria-label={`${rating}/${MAX_STARS}`}
      title={`${rating}/${MAX_STARS}`}
    >
      {Array.from({ length: MAX_STARS }).map((_, index) => (
        <Star key={index} filled={index < rounded} size={size} />
      ))}
      {showValue ? (
        <span className="ml-1.5 text-sm font-semibold text-slate-700">{rating}/{MAX_STARS}</span>
      ) : null}
    </span>
  );
}
